const DIFF_DAYS = 'days';
const START_OF_DAY = 'day';

export default function FlightGroupDaysShiftArrivalService() {
    Object.assign(this, {
        getDayShiftArrival,
    });

    function getDayShiftArrival(group) {
        if (!(group && group.Flights && group.Flights.length)) {
            return null;
        }
        const [firstFlight] = group.Flights;
        const lastFlight = group.Flights[group.Flights.length - 1];

        const departureDate = moment(firstFlight.DepartureDate).startOf(START_OF_DAY);
        const arrivalDate = moment(lastFlight.ArrivalDate).startOf(START_OF_DAY);

        return arrivalDate.diff(departureDate, DIFF_DAYS);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival-service.js